<template>
  <div>
    <b-modal id="modal_hotelPrecios" size="lg" :title="titulo"
        hide-header ok-only content-class="shadow"
        button-size="sm" centered ok-title="Cancelar" ok-variant="outline-primary">

        <hotelPrecios/>

    </b-modal>
  </div>
</template>

<script>
import hotelPrecios from '@/components/hotel-precios.vue'
export default {
  components: {
    hotelPrecios,
  },
  data() {
    return {
        titulo: "Hoteles - Turnos/Precios"
    }
  },
  computed: {
  },
  methods: {
      close() {
        alert('cerrar');
        this.hideModal();
      },
  }
}
</script>
